module.exports = __webpack_public_path__ + "img/first_ch.20edb242.jpg";